import _ from 'lodash';
import {
  deleteRequest,
  getRequest,
  patchRequest,
  postRequest
} from '../../Common/network-call';
import { shuffleComments } from '../../../util/util-common';
import { TABLE_URI_ADDON } from '../../../constants/constant';
import {
  FIELDS,
  TABLES
} from '../../../constants/section-constants/eventify-constant';
import {
  fetchGameChallengeStatus,
  setGamificationPopup
} from '../../gamification/actions';
import { showToast } from '../../Common/alertmessage';
import LocalStrings from '../../../assets/languages';
import { ALLOWED_GAME_CHALLENGE_TYPES } from '../../../constants/section-constants/gamification-constants';

export const GALLERY_IMAGES = 'GALLERY_IMAGES';
export const IMAGE_MODAL_DETAILS = 'IMAGE_MODAL_DETAILS';

export const fetchGalleryImages = (
  session,
  extra = { galleryId: null, apptabId: null, checkGamification: false },
  callback
) => {
  let filter = encodeURI(
    `(eventid=${session.eventid})AND(apptabid=${extra.apptabId})`
  );
  let related = `comments_by_galleryid,gallerylikes_by_galleryid&gallerylikes_by_galleryid.fields=likedby&comments_by_galleryid.fields=commentid`;

  if (extra?.galleryId) {
    filter = encodeURI(
      `(eventid=${session.eventid})AND(id=${extra?.galleryId})AND(apptabid=${extra.apptabId})`
    );
    related = `comments_by_galleryid,gallerylikes_by_galleryid,appuser_by_appuserid,appuser_by_comments,,appuser_by_gallerylikes&appuser_by_appuserid.fields=${FIELDS.appuser.relatedInfo}&appuser_by_comments.fields=${FIELDS.appuser.relatedInfo}&appuser_by_gallerylikes.fields=${FIELDS.appuser.relatedInfo}&comments_by_galleryid.fields=commentid,commentbyid,parentid,mediapath,comment,createdon,updatedon&gallerylikes_by_galleryid.fields=likeid,likedby,icon`;
  }

  let orderby = encodeURI('displayorder ASC, createon DESC');
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.gallery}?include_count=true&related=${related}&filter=(${filter})&order=${orderby}`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      res => {
        if (extra?.galleryId) {
          const response = res.resource.map(ea => ({
            ...ea,
            comments_by_galleryid: shuffleComments(
              'commentid',
              ea.comments_by_galleryid
            )
          }));
          callback({
            success: 1,
            data: response[0],
            count: res.meta.count
          });
        } else if (extra?.checkGamification) {
          dispatch(
            fetchGalleryContestDetails(
              session,
              { apptabId: extra?.apptabId },
              contestRes => {
                const localContestData =
                  contestRes.success && !_.isEmpty(contestRes?.data)
                    ? contestRes?.data
                    : null;

                let galleryList = res.resource;
                if (
                  !_.isEmpty(localContestData) &&
                  localContestData?.isactive &&
                  !_.isEmpty(localContestData?.result)
                ) {
                  const contestRank = _.map(
                    _.split(localContestData?.result, ','),
                    _.toInteger
                  );

                  const rankedImages = _.compact(
                    _.map(contestRank, id => _.find(galleryList, { id }))
                  );

                  const otherParticipatedImages = _.reject(galleryList, item =>
                    _.includes(rankedImages, item)
                  );

                  galleryList = _.concat(
                    rankedImages,
                    _.orderBy(
                      otherParticipatedImages,
                      ['displayorder', 'createon'],
                      ['asc', 'desc']
                    )
                  );
                }

                const resPay = {
                  resource: galleryList,
                  count: res.meta.count,
                  contestDetails: localContestData
                };

                dispatch({
                  type: GALLERY_IMAGES,
                  payload: resPay
                });
                callback({ success: 1, ...resPay });
              }
            )
          );
        } else {
          const resPay = {
            resource: res.resource,
            count: res.meta.count,
            contestDetails: null
          };

          dispatch({
            type: GALLERY_IMAGES,
            payload: resPay
          });
          callback({ success: 1, ...resPay });
        }
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const uploadGalleryImage = (
  session,
  extra = { imageUrl: null, caption: '', apptabId: null },
  callback
) => {
  if (_.isEmpty(extra?.imageUrl) || _.isNil(extra?.apptabId))
    return dispatch => {
      callback({ success: 0 });
    };

  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.gallery}`;
  let body = {
    resource: [
      {
        eventid: session.eventid,
        appuserid: session.userid,
        caption: extra?.caption,
        thumbpath: extra?.imageUrl,
        imagepath: extra?.imageUrl,
        apptabid: extra?.apptabId
      }
    ]
  };

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      res => {
        callback({ success: 1, response: res });

        // Gamification Status
        dispatch(
          fetchGameChallengeStatus(
            session,
            ALLOWED_GAME_CHALLENGE_TYPES.types.gallerypost,
            response => {
              if (response.data && response.data.iscompleted == true) {
                if (response.data.showpopup == true) {
                  response.data.challengetype =
                    ALLOWED_GAME_CHALLENGE_TYPES.types.gallerypost;
                  dispatch(setGamificationPopup(true, response.data));
                } else if (response.data?.showpopup) {
                  showToast(
                    `${LocalStrings.dynamic.kYouHaveGot} ${response.data.points} ${LocalStrings.dynamic.kPointsText}`
                  );
                }
              }
            }
          )
        );
      },
      error => {
        callback({ success: 0, response: error });
      }
    );
  };
};

export const deleteGalleryImage = (
  session,
  extra = { imageId: null, apptabId: null },
  callback
) => {
  let delUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.gallery}/${extra.imageId}`;

  return dispatch => {
    deleteRequest(
      delUrl,
      session,
      dispatch,
      res => {
        callback({ success: 1 });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const likeGalleryImage = (session, data, callback) => {
  const isDelete = data.delete;
  const isPatch = data.patch;

  const restURL = isDelete || isPatch ? `/${data.likeid}` : '';
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.gallerylikes}${restURL}`;

  let body = { resource: _.omit(data, ['delete', 'patch']) };
  if (isPatch) {
    body = _.omit(data, ['delete', 'patch', 'likedby', 'galleryid', 'likeid']);
  }

  return dispatch => {
    isDelete
      ? deleteRequest(
          url,
          session,
          dispatch,
          res => {
            callback({ success: 1 });
          },
          error => {}
        )
      : isPatch
      ? patchRequest(
          url,
          body,
          session,
          dispatch,
          res => {
            callback({ success: 1 });
          },
          error => {}
        )
      : postRequest(
          url,
          body,
          session,
          dispatch,
          res => {
            callback({ success: 1 });
          },
          error => {}
        );
  };
};

export const galleryImageModalDetails = data => {
  return dispatch => {
    dispatch({ type: IMAGE_MODAL_DETAILS, payload: data });
  };
};

export const fetchGalleryContestDetails = (
  session,
  extra = { apptabId: null },
  callback
) => {
  if (_.isNil(extra?.apptabId)) return dispatch => callback({ success: 0 });

  const fetchFilter = encodeURI(
    `(eventid=${session.eventid})AND(apptabid=${extra.apptabId})AND(challengetype=gallerycontest)`
  );
  const fetchFields = `${FIELDS.gamificationChallenge.minInfo}`;
  const fetchUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.gamificationChallenge}?fields=${fetchFields}&filter=(${fetchFilter})`;

  return dispatch => {
    getRequest(
      fetchUrl,
      session,
      dispatch,
      res => {
        callback({ success: 1, data: res?.resource?.[0] ?? {}, error: null });
      },
      error => {
        callback({ success: 0, data: null, error });
      }
    );
  };
};
